export const faqs = [
  {
    id: 1,
    question: '瓜圈速报的热度排行是怎么算出来的？',
    answer:
      '我们把公开讨论量、搜索热度、传播速度和互动密度四项指标做加权计算，得到一个 0 到 10000 之间的热度值，再按小时滚动更新。热度只反映话题声量，不代表我们对事件真假的判断。',
  },
  {
    id: 2,
    question: '榜单多久更新一次，历史数据还能查到吗？',
    answer:
      '热度值每 10 分钟刷新一次，小时榜、日榜、周榜会分别留档。你可以在热度排行页切换「今日 / 本周 / 本月」查看不同时间维度的排序变化。',
  },
  {
    id: 3,
    question: '速报内容和话题榜会重复吗？',
    answer:
      '不会。话题榜按主题归类，方便你系统性地追一条线；速报则按时间流呈现单个事件的最新进展。两者数据同源但视角不同，一个看趋势，一个看现场。',
  },
  {
    id: 4,
    question: '你们会核实每一条网络传闻吗？',
    answer:
      '我们对涉及具体人物的传闻采取谨慎原则：只汇总已经公开传播的信息，标注「传闻」「非官方」等标签，不做真伪裁决，也不鼓励对当事人进行人身攻击。',
  },
  {
    id: 5,
    question: '可以把自己发现的热点线索提交给你们吗？',
    answer:
      '当然可以。通过订阅表单留下你的邮箱和线索方向，编辑部会安排跟进。如果线索来自你本人拍摄的内容，请一并说明授权范围。',
  },
];